<template>
    <div class="app-dropdown-search-input-container">
        <input
            class="app-dropdown-search-input"
            type="text"
            :placeholder="i18n.t('ourCars.search')"
            v-model.trim="searchQuery"
        />
        <span
            class="app-dropdown-search-input-close"
            :class="{ active: !!searchQuery }"
            @click="reset"
        >
            x
        </span>
    </div>
</template>
<script src="./app-dropdown-search.ts"></script>
